import React from 'react';
export function Footer() {
  return <footer className="py-10 px-4 sm:px-6 bg-brand-navy-dark text-center text-white/50 text-[10px] sm:text-xs border-t border-white/5" data-id="element-74" data-mp="32wd2cf6gdjt0">
      <p className="leading-relaxed max-w-2xl mx-auto font-medium mb-6" data-id="element-75" data-mp="32nummremu92y">
        © 2026 Physio Ready™ — All Rights Reserved.
        <br data-id="element-76" data-mp="36oo9dhgc9hu9" />
        <br data-id="element-77" data-mp="36qhdoq3hbpz3" />
        The information provided on this website is intended for educational
        purposes only and is designed as a professional resource for physical
        therapists. It is not intended to replace independent clinical judgment,
        local regulations, or professional standards of practice. Always use
        your professional expertise and follow applicable laws and clinical
        guidelines when treating patients.
      </p>
      <div className="flex justify-center gap-4 sm:gap-6 font-bold tracking-widest uppercase" data-id="element-78" data-mp="29z6v4e3aingy">
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-79" data-mp="2ey9zrxfcyroe">
          Terms & Conditions
        </a>
        <span className="text-white/20" data-id="element-80" data-mp="3l9abhd1s8u1s">·</span>
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-81" data-mp="3la28msb12zu6">
          Privacy Policy
        </a>
        <span className="text-white/20" data-id="element-82" data-mp="3gca6l5go5xc9">·</span>
        <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-83" data-mp="3v89dwdvyftgc">
          Contact
        </a>
      </div>
    </footer>;
}